import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/code/layouts/default.vue").then(m => m.default || m))
}